import ErrorI from "@/assets/static/error.svg";
const ErrorIcon = () => {
  return <ErrorI />;
};
export default ErrorIcon;
